import React, { Component } from "react";
import {withRouter, Link} from 'react-router-dom';

import {PageWrapper} from 'components/PageWrapper';

import HttpClient from 'services/HttpClient';

const SAMPLE_CONTENT_API = '/api/v1/free_samples?sample_type=osce';

@withRouter
class SampleVideos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      osce: [],
    };
  }

  componentDidMount() {
    new HttpClient().get(`${SAMPLE_CONTENT_API}&page=1&per_page=10`)
    .then(({ body }) => {
      this.setState({
        osce: body.data.free_sample,
      });
    })
  }

  nextPage = page => {

    new HttpClient().get(`${SAMPLE_CONTENT_API}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      this.setState({
        osce: body.data.free_sample,
      });
      window.scrollTo({top: 0});
    });
  };

  render() {
    const { osce } = this.state;

    return osce.length > 0 ? (
      <PageWrapper className="sample-content-page">
        <div className="page-container">
          <h2>Sample OSCEs</h2>
        </div>
        <div className="row">
          <div className="container">
            <div className="sample-content-container-osce">
              {osce.map((content) => (
                <a
                  href={`https://pharmacistexamprep.ie${content.file_url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={`content_${content.id}`}
                >
                  {content.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </PageWrapper>
    ) : null;
  }
};

export default SampleVideos;



// WEBPACK FOOTER //
// ./src/modules/landing/containers/SampleOsce.js